const KEY_LENGTH = 32;
const IV_LENGTH = 12;

export function bytesToBase64(bytes: Uint8Array): string {
    let s = '';
    for (let i = 0; i < bytes.length; i += 1) {
        s += String.fromCharCode(bytes[i]);
    }
    return btoa(s);
}

export function base64ToBytes(b64: string): Uint8Array {
    const s = atob(b64);
    const out = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i += 1) {
        out[i] = s.charCodeAt(i);
    }
    return out;
}

export function randomBytes(length: number): Uint8Array {
    const buf = new Uint8Array(length);
    globalThis.crypto.getRandomValues(buf);
    return buf;
}

export function generateKey(): Uint8Array {
    return randomBytes(KEY_LENGTH);
}

export async function encrypt(plaintext: string, key: Uint8Array): Promise<string> {
    const iv = randomBytes(IV_LENGTH);
    const cryptoKey = await globalThis.crypto.subtle.importKey(
        'raw',
        key,
        { name: 'AES-GCM' },
        false,
        ['encrypt'],
    );
    const buf = await globalThis.crypto.subtle.encrypt(
        { name: 'AES-GCM', iv, tagLength: 128 },
        cryptoKey,
        new TextEncoder().encode(plaintext),
    );
    return `${bytesToBase64(iv)}.${bytesToBase64(new Uint8Array(buf))}`;
}

export async function decrypt(blob: string, key: Uint8Array): Promise<string> {
    const [ivB64, ctB64] = blob.split('.');
    if (!ivB64 || !ctB64) {
        throw new Error('Malformed cipher blob');
    }
    const iv = base64ToBytes(ivB64);
    const ct = base64ToBytes(ctB64);
    const cryptoKey = await globalThis.crypto.subtle.importKey(
        'raw',
        key,
        { name: 'AES-GCM' },
        false,
        ['decrypt'],
    );
    const buf = await globalThis.crypto.subtle.decrypt(
        { name: 'AES-GCM', iv, tagLength: 128 },
        cryptoKey,
        ct,
    );
    return new TextDecoder().decode(buf);
}
